import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { SERVICES } from "@/data/content";
import { scrollToSection } from "@/lib/scroll";

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="py-24 md:py-32 bg-[#101C3E]/30">
      <div className="max-w-7xl mx-auto px-6">
        <Reveal className="mb-16">
          <p className="text-xs uppercase tracking-[0.35em] text-[#d4af37] font-medium mb-6">
            What We Do
          </p>
          <h2 className="font-display text-4xl md:text-5xl font-light tracking-tight leading-tight text-slate-50 max-w-2xl">
            Everything a journey needs,{" "}
            <span className="italic text-[#d4af37]">under one roof.</span>
          </h2>
        </Reveal>

        <div className="border-t border-[#d4af37]/20">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.06}>
              <button
                data-testid={`service-row-${i}`}
                onClick={() => scrollToSection("#booking")}
                className="group w-full grid md:grid-cols-12 gap-4 md:gap-6 items-baseline border-b border-[#d4af37]/20 py-10 px-2 md:px-6 text-left hover:bg-[#101C3E]/70 transition-colors duration-500"
              >
                <span className="md:col-span-1 font-display text-xl text-[#d4af37]">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="md:col-span-4 font-display text-3xl md:text-4xl font-light tracking-tight text-slate-50 group-hover:text-[#f3e5ab] transition-colors duration-500">
                  {s.title}
                </h3>
                <p className="md:col-span-6 text-slate-400 leading-relaxed">
                  {s.desc}
                </p>
                <ArrowUpRight
                  size={24}
                  className="hidden md:block md:col-span-1 justify-self-end text-[#d4af37] opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-500"
                />
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
